import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.css']
})
export class TimePickerComponent implements OnInit {

  focused = false;
  @ViewChild('hour') hour;
  @ViewChild('minute') minute;
  @ViewChild('amPm') amPm;
  @Output() blur: EventEmitter<any> = new EventEmitter();
  dateTimeForm : FormGroup;
  constructor() {
    this.dateTimeForm = new FormGroup({
      hourInput:new FormControl(null,[Validators.required]),
      minuteInput:new FormControl(null,[Validators.required]),
      amPmInput: new FormControl("PM",[Validators.required])
    })
  }

  ngOnInit() {

  }

  focus(){
    if(!this.focused){
      this.hour.nativeElement.focus();
      this.focused = true;
    }
  }

  onBlur(input){
    this.blur.emit(input);
  }

  getTime(){
    var t = this.dateTimeForm.getRawValue();
    if(t.hourInput && ( t.minuteInput  || t.minuteInput == 0)&& t.amPmInput) {
      return `${t.hourInput}:${t.minuteInput.toString().length == 1 ? `0${t.minuteInput}` : t.minuteInput} ${t.amPmInput}`;
    }
    return null;
  }

  onHour(event) {
    var value = (event.target as HTMLInputElement).value;
    if(!value){
      return;
    }
    if (value && parseInt(value) < 1 || (isNaN(parseInt(value)))) {
      this.dateTimeForm.patchValue({
        hourInput:1
      })
    }
    if (value && parseInt(value) > 12) {
      this.dateTimeForm.patchValue({
        hourInput:12
      })
    }
  }

  onMinute(event) {
    var value = (event.target as HTMLInputElement).value;
    if (value) {
      if (value.length < 2 && parseInt(value) > 0) {
        this.dateTimeForm.patchValue({
          minuteInput:`0${value}`
        });
      }
      if (value.length > 2) {
        if (value[0] == '0') {
          this.dateTimeForm.patchValue({
            minuteInput:value.substring(1, (value.length))
          });
        } else {
          this.dateTimeForm.patchValue({
            minuteInput:value.substring(0, 2)
          });
        }
      }
      if (parseInt(value) < 0) {
        this.dateTimeForm.patchValue({
          minuteInput:'00'
        });
      }
      if (parseInt(value) > 59) {
        this.dateTimeForm.patchValue({
          minuteInput:'59'
        });
      }
      if (value == '0') {
        this.dateTimeForm.patchValue({
          minuteInput:"00"
        });
      }
    }
  }

  onAmPm() {
  }

}
